import styled from 'styled-components';

export const FileDropZone = styled.div`
  padding: ${({ theme }) => theme.spacing[6]};
  border: ${({ theme }) => theme.spacing['0.5']} dashed
    ${({ theme }) => theme.colors.neutral[200]};
  border-radius: ${({ theme }) => theme.spacing[4]};
  cursor: pointer;
`;
